  import axios              from "axios";
  import { api }            from "../_constants";
  import handleResponse     from "./handleResponse";
  import getVoucherUser     from "./handleVoucherUser";
  import getVoucherData     from "./handleVoucherData";
//import getAppStats        from "./handleAppStats";
  import getAppId           from "./handleAppId";
//import getWebServiceCount from "./handleWebServiceCount";

export const wu_LoginLogoutService = {
  wu_login,
  wu_logout,
};
//----------------------------------------------------------------------------------------------------
function wu_login(reqData) {
  const methName = "wu_login ";
  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/login";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/xml",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,//api.platformWeb,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
    //"tokenID"                     : localStorage.getItem("tokenID"),
    //"Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = "<reqAddOmtCustomer>"+
  "<email>"+new Buffer(reqData.username).toString('base64')+"</email>"+
  "<password>"+new Buffer(reqData.password).toString('base64')+"</password>"+
  "</reqAddOmtCustomer>";
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      try { localStorage.setItem("isLoggedIn",   "true");                     }catch (err1){ console.log(methName+'err1='+err1); }
      try { localStorage.setItem("tokenID",      resData.returnText);         }catch (err2){ console.log(methName+'err2='+err2); }
      try { localStorage.setItem("accessToken_RetrieveLastDate", new Date()); }catch (err2){ console.log(methName+'err6='+err2); }
      try { localStorage.setItem("accessToken",  resData.accessToken);        }catch (err3){ console.log(methName+'err3='+err3); }
      try { localStorage.setItem("refreshToken", resData.refreshToken);       }catch (err4){ console.log(methName+'err4='+err4); }
      try { localStorage.setItem("user",         resData);                    }catch (err5){ console.log(methName+'err5='+err5); }
      return resData;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
//----------------------------------------------------------------------------------------------------
function wu_logout() {
  const methName = "wu_logout ";
  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/logout";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = {

  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .put(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      console.log("++++++++++++++++++++++++++++++++++++++++++++++++++");
      console.log("wu_logout");
      console.log("++++++++++++++++++++++++++++++++++++++++++++++++++");
      localStorage.setItem("isLoggedIn","false");
      localStorage.removeItem("user");
      localStorage.removeItem("tokenID");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      return "";
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
//----------------------------------------------------------------------------------------------------
